import { createBrowserRouter } from 'react-router-dom';

import PartnerRoutes from './PartnerRoutes';
import ComingSoon from 'components/ComingSoon';

// ==============================|| ROUTING RENDER ||============================== //
// Standalone MP app: the only routes are the marketing-partner subtree.
//
// Routing model (kept identical to the source so the copied codebase's many
// hardcoded `navigate('/mp/...')` calls and `pathname.replace(/^\/mp\//)`
// regexes keep working unchanged):
//   - Router basename = '/'  (NOT '/mp').
//   - Route paths are absolute and include the `/mp` segment ('/mp/:mpId').
//   - Vite `base: '/mp/'` independently controls where assets are served.
// A visit without a partner code (e.g. `/mp/`) matches nothing meaningful — the
// code is mandatory — so it falls through to a small notice.

const router = createBrowserRouter(
    [
        PartnerRoutes,
        { path: '*', element: <ComingSoon title="Marketing partner code required" /> }
    ],
    {
        basename: import.meta.env.VITE_APP_BASE_NAME || '/'
    }
);

export default router;
